import { useCallback, useEffect, useState } from "react";
import { FEATURES } from "../../../../../config/features";
import { token, domain } from "../../../../../components/Security";
import axios from "../../../../../api/apiClient";
import { SetAuditTrail } from "../../../../../components/Reports/AuditTrailReportEmployeeSetup";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import SearchIcon from "@mui/icons-material/Search";
import { ShowAdjustmentButtons } from "./ShowAdjustmentButtons";
import { GenerateMessage } from "./GenerateMessage";
import { CreateTable } from "./CreateTable";
import { CreateSearchBarWithPlaceHolder } from "../../../../../components/CommonObjects";
import loadingSpinner from "../../../../../assets/loading.gif";
import { AddProcessForm } from "./AddProcessForm";
import { EditProcessForm } from "./EditProcessForm";
import { DeleteForm } from "./DeleteForm";
import { DeleteAllPayrollSummaryForm } from "./DeleteAllPayrollSummaryForm";
import { EmployeeSelectForm } from "./EmployeeSelectForm";
import { Button, SearchBar } from "../../../../../common/APICommon";


export function ShowTab({
	type,
	setType,
	filterPayrollPeriodId,
	filterPayTypeId,
	filterClassificationId,
	userAccess,
	payrollData,
	setPayrollData,
	payrollDataAdjustment,
	setPayrollDataAdjustment,
	otherAdditionData,
	otherDeductionData,
	otherAdjustmentData,
	otherLateAdjustmentData,
	setOtherAdditionData,
	setOtherDeductionData,
	setOtherAdjustmentData,
	setOtherLateAdjustmentData,
	showPostMessage,
	isGenerate,
	isRevert,
	isProcess,
	isPost,
	isUpload,
	setIsUpload,

	loading,
	fetchData,
	filterData,
	loadingOtherAddition,
	loadingOtherDedujction,
	loadingAdjustment,
	loadingLateAdjustment,
	filterDataAddition,
	filterDataDeduction,
	filterDataAdjustment,
	filterDataLateAdjustment,
	fetchAdditionData,
	fetchDeductionData,
	fetchAdjustmentData,
	fetchLateAdjustmentData,
	fetchDataProcessedPayroll,
	handleGenerateLateApprovedAdjustments,
	openLateAdjustmentForm,
	user,
}) {
	var processedHeader = [
		"Id",
		"Employee Id",
		"Name",
		"Classification",
		"Pay Type",
		"Total Basic",
		"Rate",
    ...(FEATURES.ALLOW_FLEXITIME ? ["Hourly Rate"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? ["Total Hours"] : ["Total Days"]),
    "Days Absent",
		"Absent/s",
		"Days Leave",
		"Leave/s",
    "Hours Undertime",
    "Undertime",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Hourly Late"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Late"]),
		...(FEATURES.PAYROLL_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["Hours Late Deduction"] : []),
		...(FEATURES.PAYROLL_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["Late Deduction"] : []),
		"Hours Night Differential",
		"Night Differential",
		"Allowance",
		"Benefits",
		"Benefits List",
		"Total Days Regular Holidays",
		"Total Regular Holiday Worked",
		"Total Regular Holidays",
		"Total Days Special Non-Working Holidays",
		"Total Special Non-Working Holidays",
    "Hours OT Regular",
    "Total OT Regular",
    "Hours OT Restday",
    "Total OT Restday",
    "Hours Holiday Special",
    "Total Holiday Special",
    "Hours Holiday Regular",
    "Total Holiday Regular",
    "Hours Restday Holiday Special",
    "Total Restday Holiday Special",
    "Hours Restday Holiday Regular",
    "Total Restday Holiday Regular",
		"SSS",
		"Pagibig",
		"Philhealth",
		"SSS Loan",
		"SSS Calamity Loan",
		"SSS Emergency Loan",
		"Pagibig Loan",
		"Pagibig Calamity Loan",
		"Cash Advance",
		"Salary Advance",
		"Other Cash Advance",
		"Other Cash Advance List",
		"Company Loans",
		"Company Loans List",
		"Tax",
		"Total Taxable Addition",
		"Total Non-Taxable Addition",
		"Additions",
		"Deductions",
		"Adjustments",
		"Partial Salary Deduction",
		"Unpaid Statutory Balance",
		"Recovered Statutory Balance",
		"Total Gross Pay",
		"Total Net Pay",
		"Date Processed",
	];
	var processedAccessor = [
		"id",
		"employeePersonalInformationEmployeeId",
		"employeePersonalInformationFullName",
		"classificationDescription",
		"payTypeDescription",
		"totalBasic",
		"rate",
    ...(FEATURES.ALLOW_FLEXITIME ? ["hourlyRate"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? ["totalHours"] : ["totalDays"]),
    "totalDaysAbsents",
		"totalAbsents",
		"totalDaysLeaves",
		"totalLeaves",
    "totalHoursUndertime",
    "totalUndertime",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalHoursLate"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalLate"]),
		...(FEATURES.PAYROLL_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["totalHoursLateDeduction"] : []),
		...(FEATURES.PAYROLL_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["totalLateDeduction"] : []),
		"totalNighDiff",
		"totalNighDiffAmount",
		"totalAllowance",
		"totalBenefits",
		"benefits",
		"totalDaysRegularHolidays",
		"totalRegularHolidayWorked",
		"totalRegularHolidays",
		"totalDaysSpecialNonWorkingHolidays",
		"totalSpecialNonWorkingHolidays",
    "totalHoursOTRegular",
    "totalOTRegular",
    "totalHoursOTRestday",
    "totalOTRestday",
    "totalHoursOTHolidaySpecial",
    "totalOTHolidaySpecial",
    "totalHoursOTHolidayRegular",
    "totalOTHolidayRegular",
    "totalHoursOTRestdayHolidaySpecial",
    "totalOTRestdayHolidaySpecial",
    "totalHoursOTRestdayHolidayRegular",
    "totalOTRestdayHolidayRegular",
		"totalSSS",
		"totalPagibig",
		"totalPhilhealth",
		"totalSSSLoan",
		"totalSSSCalamityLoan",
		"totalSSSEmergencyLoan",
		"totalPagibigLoan",
		"totalPagibigCalamityLoan",
		"totalCashAdvance",
		"totalSalaryAdvance",
		"totalOtherCashAdvance",
		"otherCashAdvances",
		"totalCompanyLoan",
		"companyLoans",
		"totalTax",
		"totalTaxableAddition",
		"totalNonTaxableAddition",
		"totalAddition",
		"totalDeduction",
		"totalAdjustment",
		"totalPartialSalaryDeduction",
		"unpaidStatutoryBalance",
		"recoveredStatutoryBalance",
		"totalGrossPay",
		"totalNetPay",
		"dateProcessed",
	];
	const [currentPage, setCurrentPage] = useState(1);
	const [loadingRequest, setLoadingRequest] = useState(false);
	const [selectedTab, setSelectedTab] = useState(0);
	// Add
	const [showAddForm, setShowAddForm] = useState(false);
	const [payrollPeriodId, setPayrollPeriodId] = useState("");
	const [employeePersonalInformationId, setEmployeePersonalInformationId] =
		useState("");
	const [
		employeePersonalInformationFullName,
		setEmployeePersonalInformationFullName,
	] = useState("");
	const [payTypeId, setPayTypeId] = useState("");
	const [totalEcola, setTotalEcola] = useState("");
	const [totalAllowance, setTotalAllowance] = useState("");
	const [totalTax, setTotalTax] = useState("");
	const [totalDays, setTotalDays] = useState("");
	const [totalDaysAbsents, setTotalDaysAbsents] = useState("");
	const [totalAbsents, setTotalAbsents] = useState("");
	const [totalDaysLeaves, setTotalDaysLeaves] = useState("");
	const [totalLeaves, setTotalLeaves] = useState("");
	const [totalDeduction, setTotalDeduction] = useState("");
	const [totalAddition, setTotalAddition] = useState("");
	const [totalAdjustment, setTotalAdjustment] = useState("");
	const [rate, setRate] = useState("");
	const [totalNighDiff, setTotalNighDiff] = useState("");
	const [totalHoursOTRegular, setTotalHoursOTRegular] = useState("");
	const [totalOTRegular, setTotalOTRegular] = useState("");
	const [totalHoursOTRegularExceeded, setTotalHoursOTRegularExceeded] =
		useState("");
	const [totalOTRegularExceeded, setTotalOTRegularExceeded] = useState("");
	const [totalHoursOTRestday, setTotalHoursOTRestday] = useState("");
	const [totalOTRestday, setTotalOTRestday] = useState("");
	const [totalHoursOTRestdayExceeded, setTotalHoursOTRestdayExceeded] =
		useState("");
	const [totalOTRestdayExceeded, setTotalOTRestdayExceeded] = useState("");
	const [totalHoursOTHolidaySpecial, setTotalHoursOTHolidaySpecial] =
		useState("");
	const [totalOTHolidaySpecial, setTotalOTHolidaySpecial] = useState("");
	const [
		totalHoursOTHolidaySpecialExceeded,
		setTotalHoursOTHolidaySpecialExceeded,
	] = useState("");
	const [totalOTHolidaySpecialExceeded, setTotalOTHolidaySpecialExceeded] =
		useState("");
	const [totalHoursOTHolidayRegular, setTotalHoursOTHolidayRegular] =
		useState("");
	const [totalOTHolidayRegular, setTotalOTHolidayRegular] = useState("");
	const [
		totalHoursOTHolidayRegularExceeded,
		setTotalHoursOTHolidayRegularExceeded,
	] = useState("");
	const [totalOTHolidayRegularExceeded, setTotalOTHolidayRegularExceeded] =
		useState("");
	const [
		totalHoursOTRestdayHolidaySpecial,
		setTotalHoursOTRestdayHolidaySpecial,
	] = useState("");
	const [totalOTRestdayHolidaySpecial, setTotalOTRestdayHolidaySpecial] =
		useState("");
	const [
		totalHoursOTRestdayHolidaySpecialExceeded,
		setTotalHoursOTRestdayHolidaySpecialExceeded,
	] = useState("");
	const [
		totalOTRestdayHolidaySpecialExceeded,
		setTotalOTRestdayHolidaySpecialExceeded,
	] = useState("");
	const [
		totalHoursOTRestdayHolidayRegular,
		setTotalHoursOTRestdayHolidayRegular,
	] = useState("");
	const [totalOTRestdayHolidayRegular, setTotalOTRestdayHolidayRegular] =
		useState("");
	const [
		totalHoursOTRestdayHolidayRegularExceeded,
		setTotalHoursOTRestdayHolidayRegularExceeded,
	] = useState("");
	const [
		totalOTRestdayHolidayRegularExceeded,
		setTotalOTRestdayHolidayRegularExceeded,
	] = useState("");
	const [totalSSS, setTotalSSS] = useState("");
	const [totalPagibig, setTotalPagibig] = useState("");
	const [totalPhilhealth, setTotalPhilhealth] = useState("");
	const [totalHoursUndertime, setTotalHoursUndertime] = useState("");
	const [totalUndertime, setTotalUndertime] = useState("");
	const [totalHoursLate, setTotalHoursLate] = useState("");
	const [totalLate, setTotalLate] = useState("");
	const [totalBasic, setTotalBasic] = useState("");
	const [totalGrossPay, setTotalGrossPay] = useState("");
	const [totalNetPay, setTotalNetPay] = useState("");
	const [dateProcessed, setDateProcessed] = useState("");
	const [userId, setUserId] = useState("");
	//Update
	const [showEditForm, setShowEditForm] = useState(false);
	const [editById, setEditById] = useState("");
	const [dataToEdit, setDataToEdit] = useState([]);
	// Delete
	const [showDeleteForm, setShowDeleteForm] = useState(false);
	const [deleteById, setDeleteById] = useState([]);
	// Delete All
	const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
	const [payrollIdForDelete, setPayrollIdForDelete] = useState("");

	const [showEmployeeForm, setShowEmployeeForm] = useState(false);
	// const [generateMessage, setGenerateMessage] = useState(false);
	const [successPostMessage, setSuccessPostMessage] = useState(false);
	//Request Messages -start
	const [showRequestMessage, setShowRequestMessage] = useState(false);
	const [requestMessage, setRequestMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState("");
	useEffect(() => {
		if (showRequestMessage) {
			const timeoutId = setTimeout(() => {
				setShowRequestMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
	}, [showRequestMessage]);

	const apiUrl = domain + "/api/PayrollSummaryStaging/";

	const handleFilter = (value) => {
		setCurrentPage(1);
		const lowercaseValue = value.toLowerCase();
		var res = filterData.filter((f) =>
			f.employeePersonalInformationFullName
				.toLowerCase()
				.includes(lowercaseValue)
		);

		setPayrollData(res);
	};
	const handleSubmit = async (event) => {
		event.preventDefault();

		if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
			alert("Required to fill up all data");
			return; // Exit early if fields are empty
		}

		const currentDate = new Date();

		const data = {
			payrollPeriodId: payrollPeriodId,
			employeePersonalInformationId: employeePersonalInformationId,
			payTypeId: payTypeId,
			totalEcola: totalEcola ? totalEcola : 0,
			totalAllowance: totalAllowance ? totalAllowance : 0,
			totalTax: totalTax ? totalTax : 0,
			totalDays: totalDays ? totalDays : 0,
			totalDaysAbsents: totalDaysAbsents ? totalDaysAbsents : 0,
			totalAbsents: totalAbsents ? totalAbsents : 0,
			totalDaysLeaves: totalDaysLeaves ? totalDaysLeaves : 0,
			totalLeaves: totalLeaves ? totalLeaves : 0,
			totalDeduction: totalDeduction ? totalDeduction : 0,
			totalAddition: totalAddition ? totalAddition : 0,
			totalAdjustment: totalAdjustment ? totalAdjustment : 0,
			rate: rate ? rate : 0,
			totalNighDiff: totalNighDiff ? totalNighDiff : 0,
			totalHoursOTRegular: totalHoursOTRegular ? totalHoursOTRegular : 0,
			totalOTRegular: totalOTRegular ? totalOTRegular : 0,
			totalHoursOTRegularExceeded: totalHoursOTRegularExceeded
				? totalHoursOTRegularExceeded
				: 0,
			totalOTRegularExceeded: totalOTRegularExceeded
				? totalOTRegularExceeded
				: 0,
			totalHoursOTRestday: totalHoursOTRestday ? totalHoursOTRestday : 0,
			totalOTRestday: totalOTRestday ? totalOTRestday : 0,
			totalHoursOTRestdayExceeded: totalHoursOTRestdayExceeded
				? totalHoursOTRestdayExceeded
				: 0,
			totalOTRestdayExceeded: totalOTRestdayExceeded
				? totalOTRestdayExceeded
				: 0,
			totalHoursOTHolidaySpecial: totalHoursOTHolidaySpecial
				? totalHoursOTHolidaySpecial
				: 0,
			totalOTHolidaySpecial: totalOTHolidaySpecial ? totalOTHolidaySpecial : 0,
			totalHoursOTHolidaySpecialExceeded: totalHoursOTHolidaySpecialExceeded
				? totalHoursOTHolidaySpecialExceeded
				: 0,
			totalOTHolidaySpecialExceeded: totalOTHolidaySpecialExceeded
				? totalOTHolidaySpecialExceeded
				: 0,
			totalHoursOTHolidayRegular: totalHoursOTHolidayRegular
				? totalHoursOTHolidayRegular
				: 0,
			totalOTHolidayRegular: totalOTHolidayRegular ? totalOTHolidayRegular : 0,
			totalHoursOTHolidayRegularExceeded: totalHoursOTHolidayRegularExceeded
				? totalHoursOTHolidayRegularExceeded
				: 0,
			totalOTHolidayRegularExceeded: totalOTHolidayRegularExceeded
				? totalOTHolidayRegularExceeded
				: 0,
			totalHoursOTRestdayHolidaySpecial: totalHoursOTRestdayHolidaySpecial
				? totalHoursOTRestdayHolidaySpecial
				: 0,
			totalOTRestdayHolidaySpecial: totalOTRestdayHolidaySpecial
				? totalOTRestdayHolidaySpecial
				: 0,
			totalHoursOTRestdayHolidaySpecialExceeded:
				totalHoursOTRestdayHolidaySpecialExceeded
					? totalHoursOTRestdayHolidaySpecialExceeded
					: 0,
			totalOTRestdayHolidaySpecialExceeded: totalOTRestdayHolidaySpecialExceeded
				? totalOTRestdayHolidaySpecialExceeded
				: 0,
			totalHoursOTRestdayHolidayRegular: totalHoursOTRestdayHolidayRegular
				? totalHoursOTRestdayHolidayRegular
				: 0,
			totalOTRestdayHolidayRegular: totalOTRestdayHolidayRegular
				? totalOTRestdayHolidayRegular
				: 0,
			totalHoursOTRestdayHolidayRegularExceeded:
				totalHoursOTRestdayHolidayRegularExceeded
					? totalHoursOTRestdayHolidayRegularExceeded
					: 0,
			totalOTRestdayHolidayRegularExceeded: totalOTRestdayHolidayRegularExceeded
				? totalOTRestdayHolidayRegularExceeded
				: 0,
			totalSSS: totalSSS ? totalSSS : 0,
			totalPagibig: totalPagibig ? totalPagibig : 0,
			totalPhilhealth: totalPhilhealth ? totalPhilhealth : 0,
			totalHoursUndertime: totalHoursUndertime ? totalHoursUndertime : 0,
			totalUndertime: totalUndertime ? totalUndertime : 0,
			totalHoursLate: totalHoursLate ? totalHoursLate : 0,
			totalLate: totalLate ? totalLate : 0,
			totalBasic: totalBasic ? totalBasic : 0,
			totalGrossPay: totalGrossPay ? totalGrossPay : 0,
			totalNetPay: totalNetPay ? totalNetPay : 0,
			dateProcessed: currentDate,
			userId: userId ? userId : 0,
		};

		try {
			setLoadingRequest(true);
			await axios.post(apiUrl, data, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});
			console.log("Data added successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset form fields
			await fetchData(); // Assuming fetchData() fetches the updated data for the table
			setPayrollPeriodId("");
			setEmployeePersonalInformationId("");
			setPayTypeId("");
			setTotalEcola("");
			setTotalAllowance("");
			setTotalTax("");
			setTotalDays("");
			setTotalDaysAbsents("");
			setTotalAbsents("");
			setTotalDaysLeaves("");
			setTotalLeaves("");
			setTotalDeduction("");
			setTotalAddition("");
			setTotalAdjustment("");
			setRate("");
			setTotalNighDiff("");
			setTotalHoursOTRegular("");
			setTotalOTRegular("");
			setTotalHoursOTRegularExceeded("");
			setTotalOTRegularExceeded("");
			setTotalHoursOTRestday("");
			setTotalOTRestday("");
			setTotalHoursOTRestdayExceeded("");
			setTotalOTRestdayExceeded("");
			setTotalHoursOTHolidaySpecial("");
			setTotalOTHolidaySpecial("");
			setTotalHoursOTHolidaySpecialExceeded("");
			setTotalOTHolidaySpecialExceeded("");
			setTotalHoursOTHolidayRegular("");
			setTotalOTHolidayRegular("");
			setTotalHoursOTHolidayRegularExceeded("");
			setTotalOTHolidayRegularExceeded("");
			setTotalHoursOTRestdayHolidaySpecial("");
			setTotalOTRestdayHolidaySpecial("");
			setTotalHoursOTRestdayHolidaySpecialExceeded("");
			setTotalOTRestdayHolidaySpecialExceeded("");
			setTotalHoursOTRestdayHolidayRegular("");
			setTotalOTRestdayHolidayRegular("");
			setTotalHoursOTRestdayHolidayRegularExceeded("");
			setTotalOTRestdayHolidayRegularExceeded("");
			setTotalSSS("");
			setTotalPagibig("");
			setTotalPhilhealth("");
			setTotalHoursUndertime("");
			setTotalUndertime("");
			setTotalHoursLate("");
			setTotalLate("");
			setTotalBasic("");
			setTotalGrossPay("");
			setTotalNetPay("");
			setDateProcessed("");
			setUserId("");
			setShowAddForm(false); // Hide the add form
		} catch (error) {
			console.error("There was a problem adding data:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowAddForm(false);
	};
	const handleUpdate = async (event) => {
		event.preventDefault();

		if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
			alert("Required to fill up all data");
			return; // Exit early if fields are empty
		}

		const data = {
			payrollPeriodId: payrollPeriodId,
			employeePersonalInformationId: employeePersonalInformationId,
			payTypeId: payTypeId,
			totalEcola: totalEcola ? totalEcola : 0,
			totalAllowance: totalAllowance ? totalAllowance : 0,
			totalTax: totalTax ? totalTax : 0,
			totalDays: totalDays ? totalDays : 0,
			totalDaysAbsents: totalDaysAbsents ? totalDaysAbsents : 0,
			totalAbsents: totalAbsents ? totalAbsents : 0,
			totalDaysLeaves: totalDaysLeaves ? totalDaysLeaves : 0,
			totalLeaves: totalLeaves ? totalLeaves : 0,
			totalDeduction: totalDeduction ? totalDeduction : 0,
			totalAddition: totalAddition ? totalAddition : 0,
			totalAdjustment: totalAdjustment ? totalAdjustment : 0,
			rate: rate ? rate : 0,
			totalNighDiff: totalNighDiff ? totalNighDiff : 0,
			totalHoursOTRegular: totalHoursOTRegular ? totalHoursOTRegular : 0,
			totalOTRegular: totalOTRegular ? totalOTRegular : 0,
			totalHoursOTRegularExceeded: totalHoursOTRegularExceeded
				? totalHoursOTRegularExceeded
				: 0,
			totalOTRegularExceeded: totalOTRegularExceeded
				? totalOTRegularExceeded
				: 0,
			totalHoursOTRestday: totalHoursOTRestday ? totalHoursOTRestday : 0,
			totalOTRestday: totalOTRestday ? totalOTRestday : 0,
			totalHoursOTRestdayExceeded: totalHoursOTRestdayExceeded
				? totalHoursOTRestdayExceeded
				: 0,
			totalOTRestdayExceeded: totalOTRestdayExceeded
				? totalOTRestdayExceeded
				: 0,
			totalHoursOTHolidaySpecial: totalHoursOTHolidaySpecial
				? totalHoursOTHolidaySpecial
				: 0,
			totalOTHolidaySpecial: totalOTHolidaySpecial ? totalOTHolidaySpecial : 0,
			totalHoursOTHolidaySpecialExceeded: totalHoursOTHolidaySpecialExceeded
				? totalHoursOTHolidaySpecialExceeded
				: 0,
			totalOTHolidaySpecialExceeded: totalOTHolidaySpecialExceeded
				? totalOTHolidaySpecialExceeded
				: 0,
			totalHoursOTHolidayRegular: totalHoursOTHolidayRegular
				? totalHoursOTHolidayRegular
				: 0,
			totalOTHolidayRegular: totalOTHolidayRegular ? totalOTHolidayRegular : 0,
			totalHoursOTHolidayRegularExceeded: totalHoursOTHolidayRegularExceeded
				? totalHoursOTHolidayRegularExceeded
				: 0,
			totalOTHolidayRegularExceeded: totalOTHolidayRegularExceeded
				? totalOTHolidayRegularExceeded
				: 0,
			totalHoursOTRestdayHolidaySpecial: totalHoursOTRestdayHolidaySpecial
				? totalHoursOTRestdayHolidaySpecial
				: 0,
			totalOTRestdayHolidaySpecial: totalOTRestdayHolidaySpecial
				? totalOTRestdayHolidaySpecial
				: 0,
			totalHoursOTRestdayHolidaySpecialExceeded:
				totalHoursOTRestdayHolidaySpecialExceeded
					? totalHoursOTRestdayHolidaySpecialExceeded
					: 0,
			totalOTRestdayHolidaySpecialExceeded: totalOTRestdayHolidaySpecialExceeded
				? totalOTRestdayHolidaySpecialExceeded
				: 0,
			totalHoursOTRestdayHolidayRegular: totalHoursOTRestdayHolidayRegular
				? totalHoursOTRestdayHolidayRegular
				: 0,
			totalOTRestdayHolidayRegular: totalOTRestdayHolidayRegular
				? totalOTRestdayHolidayRegular
				: 0,
			totalHoursOTRestdayHolidayRegularExceeded:
				totalHoursOTRestdayHolidayRegularExceeded
					? totalHoursOTRestdayHolidayRegularExceeded
					: 0,
			totalOTRestdayHolidayRegularExceeded: totalOTRestdayHolidayRegularExceeded
				? totalOTRestdayHolidayRegularExceeded
				: 0,
			totalSSS: totalSSS ? totalSSS : 0,
			totalPagibig: totalPagibig ? totalPagibig : 0,
			totalPhilhealth: totalPhilhealth ? totalPhilhealth : 0,
			totalHoursUndertime: totalHoursUndertime ? totalHoursUndertime : 0,
			totalUndertime: totalUndertime ? totalUndertime : 0,
			totalHoursLate: totalHoursLate ? totalHoursLate : 0,
			totalLate: totalLate ? totalLate : 0,
			totalBasic: totalBasic ? totalBasic : 0,
			totalGrossPay: totalGrossPay ? totalGrossPay : 0,
			totalNetPay: totalNetPay ? totalNetPay : 0,
			dateProcessed: dateProcessed,
			userId: userId ? userId : 0,
		};

		try {
			setLoadingRequest(true);
			await axios.put(apiUrl + `${editById}`, data, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});
			console.log("Data added successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset form fields
			await fetchData(); // Assuming fetchData() fetches the updated data for the table
			setPayrollPeriodId("");
			setEmployeePersonalInformationId("");
			setPayTypeId("");
			setTotalEcola("");
			setTotalAllowance("");
			setTotalTax("");
			setTotalDays("");
			setTotalDaysAbsents("");
			setTotalAbsents("");
			setTotalDaysLeaves("");
			setTotalLeaves("");
			setTotalDeduction("");
			setTotalAddition("");
			setTotalAdjustment("");
			setRate("");
			setTotalNighDiff("");
			setTotalHoursOTRegular("");
			setTotalOTRegular("");
			setTotalHoursOTRegularExceeded("");
			setTotalOTRegularExceeded("");
			setTotalHoursOTRestday("");
			setTotalOTRestday("");
			setTotalHoursOTRestdayExceeded("");
			setTotalOTRestdayExceeded("");
			setTotalHoursOTHolidaySpecial("");
			setTotalOTHolidaySpecial("");
			setTotalHoursOTHolidaySpecialExceeded("");
			setTotalOTHolidaySpecialExceeded("");
			setTotalHoursOTHolidayRegular("");
			setTotalOTHolidayRegular("");
			setTotalHoursOTHolidayRegularExceeded("");
			setTotalOTHolidayRegularExceeded("");
			setTotalHoursOTRestdayHolidaySpecial("");
			setTotalOTRestdayHolidaySpecial("");
			setTotalHoursOTRestdayHolidaySpecialExceeded("");
			setTotalOTRestdayHolidaySpecialExceeded("");
			setTotalHoursOTRestdayHolidayRegular("");
			setTotalOTRestdayHolidayRegular("");
			setTotalHoursOTRestdayHolidayRegularExceeded("");
			setTotalOTRestdayHolidayRegularExceeded("");
			setTotalSSS("");
			setTotalPagibig("");
			setTotalPhilhealth("");
			setTotalHoursUndertime("");
			setTotalUndertime("");
			setTotalHoursLate("");
			setTotalLate("");
			setTotalBasic("");
			setTotalGrossPay("");
			setTotalNetPay("");
			setDateProcessed("");
			setUserId("");
			setShowEditForm(false); // Hide the add form
		} catch (error) {
			console.error("There was a problem adding data:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowEditForm(false);
	};
	const handleDelete = async () => {
		try {
			setLoadingRequest(true);
			await axios.delete(apiUrl + `${deleteById}`, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});
			console.log("Deleted successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset state
			await fetchData(); // Assuming fetchData() fetches the updated data for the table
			setShowDeleteForm(false);
			setDeleteById("");
		} catch (error) {
			console.error("There was a problem deleting employee:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowDeleteForm(false);
	};
	const handleDeleteAll = async () => {
		if (!payrollIdForDelete) {
			alert("Please select payroll period id");
			return; // Exit early if fields are empty
		}

		try {
			setLoadingRequest(true);
			await axios.delete(apiUrl + `payrollperiod/${payrollIdForDelete}`, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});
			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "logout",
				field: "Processed Delete All",
				newValue: `-`,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});

			await fetchData(); // Assuming fetchData() fetches the updated data for the table

			console.log("Deleted successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset state
			setShowDeleteAllForm(false);
			setPayrollIdForDelete("");
		} catch (error) {
			console.error("There was a problem deleting employee:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowDeleteAllForm(false);
	};
	const handleGenerate = useCallback(async () => {
		await fetchAdditionData();
		await fetchDeductionData();
		await fetchAdjustmentData();
		await fetchLateAdjustmentData();
		await fetchDataProcessedPayroll();
	}, [
		fetchAdditionData,
		fetchDeductionData,
		fetchAdjustmentData,
		fetchLateAdjustmentData,
		fetchDataProcessedPayroll,
	]);
	useEffect(() => {
		fetchAdditionData();
		fetchDeductionData();
		fetchAdjustmentData();
		fetchLateAdjustmentData();
		fetchDataProcessedPayroll();
	}, [
		type,
		handleGenerate,
		showPostMessage,
		fetchAdditionData,
		fetchDeductionData,
		fetchAdjustmentData,
		fetchLateAdjustmentData,
		fetchDataProcessedPayroll,
		isGenerate,
		isRevert,
		isProcess,
		isPost,
		isUpload,
	]);

	const handleSelectChange = (index) => {
		setSelectedTab(index);
		setType(index);
	};

	useEffect(() => {
		if (showEditForm) {
			setPayrollPeriodId(dataToEdit.payrollPeriodId);
			setEmployeePersonalInformationId(
				dataToEdit.employeePersonalInformationId
			);
			setEmployeePersonalInformationFullName(
				dataToEdit.employeePersonalInformationFullName
			);
			setPayTypeId(dataToEdit.payTypeId);
			setTotalEcola(dataToEdit.totalEcola);
			setTotalAllowance(dataToEdit.totalAllowance);
			setTotalTax(dataToEdit.totalTax);
			setTotalDays(dataToEdit.totalDays);
			setTotalDaysAbsents(dataToEdit.totalDaysAbsents);
			setTotalAbsents(dataToEdit.totalAbsents);
			setTotalDaysLeaves(dataToEdit.totalDaysLeaves);
			setTotalLeaves(dataToEdit.totalLeaves);
			setTotalDeduction(dataToEdit.totalDeduction);
			setTotalAddition(dataToEdit.totalAddition);
			setTotalAdjustment(dataToEdit.totalAdjustment);
			setRate(dataToEdit.rate);
			setTotalNighDiff(dataToEdit.totalNighDiff);
			setTotalHoursOTRegular(dataToEdit.totalHoursOTRegular);
			setTotalOTRegular(dataToEdit.totalOTRegular);
			setTotalHoursOTRegularExceeded(dataToEdit.totalHoursOTRegularExceeded);
			setTotalOTRegularExceeded(dataToEdit.totalOTRegularExceeded);
			setTotalHoursOTRestday(dataToEdit.totalHoursOTRestday);
			setTotalOTRestday(dataToEdit.totalOTRestday);
			setTotalHoursOTRestdayExceeded(dataToEdit.totalHoursOTRestdayExceeded);
			setTotalOTRestdayExceeded(dataToEdit.totalOTRestdayExceeded);
			setTotalHoursOTHolidaySpecial(dataToEdit.totalHoursOTHolidaySpecial);
			setTotalOTHolidaySpecial(dataToEdit.totalOTHolidaySpecial);
			setTotalHoursOTHolidaySpecialExceeded(
				dataToEdit.totalHoursOTHolidaySpecialExceeded
			);
			setTotalOTHolidaySpecialExceeded(
				dataToEdit.totalOTHolidaySpecialExceeded
			);
			setTotalHoursOTHolidayRegular(dataToEdit.totalHoursOTHolidayRegular);
			setTotalOTHolidayRegular(dataToEdit.totalOTHolidayRegular);
			setTotalHoursOTHolidayRegularExceeded(
				dataToEdit.totalHoursOTHolidayRegularExceeded
			);
			setTotalOTHolidayRegularExceeded(
				dataToEdit.totalOTHolidayRegularExceeded
			);
			setTotalHoursOTRestdayHolidaySpecial(
				dataToEdit.totalHoursOTRestdayHolidaySpecial
			);
			setTotalOTRestdayHolidaySpecial(dataToEdit.totalOTRestdayHolidaySpecial);
			setTotalHoursOTRestdayHolidaySpecialExceeded(
				dataToEdit.totalHoursOTRestdayHolidaySpecialExceeded
			);
			setTotalOTRestdayHolidaySpecialExceeded(
				dataToEdit.totalOTRestdayHolidaySpecialExceeded
			);
			setTotalHoursOTRestdayHolidayRegular(
				dataToEdit.totalHoursOTRestdayHolidayRegular
			);
			setTotalOTRestdayHolidayRegular(dataToEdit.totalOTRestdayHolidayRegular);
			setTotalHoursOTRestdayHolidayRegularExceeded(
				dataToEdit.totalHoursOTRestdayHolidayRegularExceeded
			);
			setTotalOTRestdayHolidayRegularExceeded(
				dataToEdit.totalOTRestdayHolidayRegularExceeded
			);
			setTotalSSS(dataToEdit.totalSSS);
			setTotalPagibig(dataToEdit.totalPagibig);
			setTotalPhilhealth(dataToEdit.totalPhilhealth);
			setTotalHoursUndertime(dataToEdit.totalHoursUndertime);
			setTotalUndertime(dataToEdit.totalUndertime);
			setTotalHoursLate(dataToEdit.totalHoursLate);
			setTotalLate(dataToEdit.totalLate);
			setTotalBasic(dataToEdit.totalBasic);
			setTotalGrossPay(dataToEdit.totalGrossPay);
			setTotalNetPay(dataToEdit.totalNetPay);
			setDateProcessed(dataToEdit.dateProcessed);
			setUserId(dataToEdit.userId);
		}

		if (successPostMessage) {
			const timeoutId = setTimeout(() => {
				setSuccessPostMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
	}, [
		showEditForm,
		dataToEdit,
		successPostMessage,
		type,
		handleGenerate,
		showPostMessage,
		fetchData,
		isGenerate,
		isRevert,
		isProcess,
		isPost,
	]);
	const editHandleClick = (data) => {
		setEditById(data.id);
		setDataToEdit(data);
		setShowEditForm(true);
	};
	const deleteHandleClick = (data) => {
		setShowDeleteForm(true);
		setDeleteById(data.id);
	};
	const deleteAllHandleClick = (data) => {
		setShowDeleteAllForm(true);
	};
	const closeAddHandleClick = () => {
		setShowAddForm(false);
	};
	const closeEditHandleClick = () => {
		setShowEditForm(false);
	};
	const closeDeleteHandleClick = () => {
		setShowDeleteForm(false);
	};
	const closeDeleteAllHandleClick = () => {
		setShowDeleteAllForm(false);
	};
	const closeEmployeeForm = () => {
		setShowEmployeeForm(false);
	};

	function formatDate(dateString) {
		if (!dateString) {
			return "";
		}
		const date = new Date(dateString);
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
		const day = String(date.getDate()).padStart(2, "0");
		const year = date.getFullYear();
		return `${month}/${day}/${year}`;
	}

	const exportToExcel = async () => {
		if (payrollData.length === 0) {
			setShowRequestMessage(true);
			setIsSuccess(false);
			setRequestMessage("No data to extract");
			return;
		}

		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet();

		const arrayList = (type, value) => {
			if (type === "otherCashAdvances" || type === "companyLoans") {
				if (Array.isArray(value) && value.length > 0) {
					// Format each cash advance as 'description - defaultDeduction'
					return value
						.map((ca) => `${ca.description} - ${ca.defaultDeduction}`)
						.join(", ");
				}
				return "";
			}

			if (type === "benefits") {
				if (Array.isArray(value) && value.length > 0) {
					// Format each cash advance as 'description - defaultDeduction'
					return value.map((ca) => `${ca.name} - ${ca.amount}`).join(", ");
				}
				return "";
			}
		};

		const header = [
			"Id",
			"Employee Id",
			"Name",
			"Classification",
			"Pay Type",
			"Total Basic",
			"Rate",
			"Hourly Rate",
			"Total Days",
			"Days Absent",
			"Absent/s",
			"Days Leave",
			"Leave/s",
			"Hours Undertime",
			"Undertime",
			"Hours Late",
			"Late",
			"Hours Night Differential",
			"Night Differential",
			"Allowance",
			"Benefits",
			"Benefits List",
			"Total Days Regular Holidays",
			"Total Regular Holiday Worked",
			"Total Regular Holidays",
			"Total Days Special Non-Working Holidays",
			"Total Special Non-Working Holidays",
			"Hours OT Regular",
			"Total OT Regular",
			"Hours OT Restday",
			"Total OT Restday",
			"Hours Holiday Special",
			"Total Holiday Special",
			"Hours Holiday Regular",
			"Total Holiday Regular",
			"Hours Restday Holiday Special",
			"Total Restday Holiday Special",
			"Hours Restday Holiday Regular",
			"Total Restday Holiday Regular",
			"SSS",
			"Pagibig",
			"Philhealth",
			"SSS Loan",
			"SSS Calamity Loan",
			"SSS Emergency Loan",
			"Pagibig Loan",
			"Pagibig Calamity Loan",
			"Cash Advance",
			"Other Cash Advance",
			"Other Cash Advance List",
			"Company Loans",
			"Company Loans List",
			"Tax",
			"Additions",
			"Deductions",
			"Adjustments",
			"Partial Salary Deduction",
			"Total Gross Pay",
			"Total Net Pay",
			"Date Processed",
		];
		const headerRow = worksheet.addRow(header);
		worksheet.columns = [
			{ key: "id", width: 30 },
			{ key: "employeePersonalInformationEmployeeId", width: 30 },
			{ key: "employeePersonalInformationFullName", width: 30 },
			{ key: "classificationDescription", width: 30 },
			{ key: "payTypeDescription", width: 30 },
			{ key: "totalBasic", width: 30 },
			{ key: "rate", width: 20 },
			{ key: "hourlyRate", width: 20 },
			{ key: "totalDays", width: 20 },
			{ key: "totalDaysAbsents", width: 20 },
			{ key: "totalAbsents", width: 20 },
			{ key: "totalDaysLeaves", width: 20 },
			{ key: "totalLeaves", width: 20 },
			{ key: "totalHoursUndertime", width: 20 },
			{ key: "totalUndertime", width: 20 },
			{ key: "totalHoursLate", width: 20 },
			{ key: "totalLate", width: 20 },
			{ key: "totalNighDiff", width: 20 },
			{ key: "totalNighDiffAmount", width: 20 },
			{ key: "totalLate", width: 20 },
			{ key: "totalAllowance", width: 20 },
			{ key: "totalBenefits", width: 20 },
			{ key: "benefits", width: 20 },
			{ key: "totalDaysRegularHolidays", width: 20 },
			{ key: "totalRegularHolidayWorked", width: 20 },
			{ key: "totalRegularHolidays", width: 20 },
			{ key: "totalDaysSpecialNonWorkingHolidays", width: 20 },
			{ key: "totalSpecialNonWorkingHolidays", width: 20 },
			{ key: "totalHoursOTRegular", width: 20 },
			{ key: "totalOTRegular", width: 20 },
			{ key: "totalHoursOTRestday", width: 20 },
			{ key: "totalOTRestday", width: 20 },
			{ key: "totalHoursOTHolidaySpecial", width: 20 },
			{ key: "totalOTHolidaySpecial", width: 20 },
			{ key: "totalHoursOTHolidayRegular", width: 20 },
			{ key: "totalOTHolidayRegular", width: 20 },
			{ key: "totalSSS", width: 20 },
			{ key: "totalPagibig", width: 20 },
			{ key: "totalPhilhealth", width: 20 },
			{ key: "totalSSSLoan", width: 20 },
			{ key: "totalSSSCalamityLoan", width: 20 },
			{ key: "totalSSSEmergencyLoan", width: 20 },
			{ key: "totalPagibigLoan", width: 20 },
			{ key: "totalPagibigCalamityLoan", width: 20 },
			{ key: "totalCashAdvance", width: 20 },
			{ key: "totalOtherCashAdvance", width: 20 },
			{ key: "otherCashAdvances", width: 20 },
			{ key: "totalCompanyLoan", width: 20 },
			{ key: "companyLoans", width: 20 },
			{ key: "totalTax", width: 20 },
			{ key: "totalAddition", width: 20 },
			{ key: "totalDeduction", width: 20 },
			{ key: "totalAdjustment", width: 20 },
			{ key: "totalPartialSalaryDeduction", width: 20 },
			{ key: "totalGrossPay", width: 20 },
			{ key: "totalNetPay", width: 20 },
			{ key: "dateProcessed", width: 20 },
		];
		headerRow.eachCell((cell) => {
			cell.font = { bold: true };
			cell.alignment = { horizontal: "center" };
			cell.border = {
				top: { style: "thin" },
				left: { style: "thin" },
				bottom: { style: "thin" },
				right: { style: "thin" },
			};
			cell.fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "92d050" },
			};
		});

		payrollData.forEach((item) => {
			worksheet.addRow([
				item.id,
				item.employeePersonalInformationEmployeeId,
				item.employeePersonalInformationFullName,
				item.classificationDescription,
				item.payTypeDescription,
				item.totalBasic.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.rate.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
        item.hourlyRate.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalDays.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalDaysAbsents.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalAbsents.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalDaysLeaves.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalLeaves.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursUndertime.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalUndertime.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursLate.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalLate.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalNighDiff.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalNighDiffAmount.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalAllowance.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalBenefits.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				arrayList("benefits", item.benefits),
				item.totalDaysRegularHolidays.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalRegularHolidayWorked.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalRegularHolidays,
				item.totalDaysSpecialNonWorkingHolidays.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalSpecialNonWorkingHolidays.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursOTRegular.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOTRegular.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursOTRestday.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOTRestday.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursOTHolidaySpecial.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOTHolidaySpecial.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursOTHolidayRegular.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOTHolidayRegular.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursOTRestdayHolidaySpecial.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOTRestdayHolidaySpecial.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalHoursOTRestdayHolidayRegular.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOTRestdayHolidayRegular.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalSSS.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalPagibig.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalPhilhealth.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalSSSLoan.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalSSSCalamityLoan.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
        item.totalSSSEmergencyLoan.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalPagibigLoan.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalPagibigCalamityLoan.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalCashAdvance.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalOtherCashAdvance.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				arrayList("otherCashAdvances", item.otherCashAdvances),
				item.totalCompanyLoan.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				arrayList("companyLoans", item.companyLoans),
				item.totalTax.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalAddition.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalDeduction.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalPartialSalaryDeduction.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalAdjustment.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalGrossPay.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				item.totalNetPay.toLocaleString("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}),
				formatDate(item.dateProcessed),
			]);
		});

		const buffer = await workbook.xlsx.writeBuffer();
		const blob = new Blob([buffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		saveAs(blob, "Payroll_data.xlsx");
	};

	return (
		<div>
			<Tabs
				selectedIndex={selectedTab}
				onSelect={(index) => handleSelectChange(index)}
			>
				<TabList>
					<Tab>
						<b>ADJUSTMENTS</b>
					</Tab>
					<Tab>
						<b>PROCESSED</b>
					</Tab>
				</TabList>
				<div className="payrollTab">
					<TabPanel>
						<div>
							<ShowAdjustmentButtons
								otherAdditionData={otherAdditionData}
								otherDeductionData={otherDeductionData}
								otherAdjustmentData={otherAdjustmentData}
								otherLateAdjustmentData={otherLateAdjustmentData}
								setOtherAdditionData={setOtherAdditionData}
								setOtherDeductionData={setOtherDeductionData}
								setOtherAdjustmentData={setOtherAdjustmentData}
								setOtherLateAdjustmentData={setOtherLateAdjustmentData}
								payrollData={payrollDataAdjustment}
								setPayrollData={setPayrollDataAdjustment}
								filterPayrollPeriodId={filterPayrollPeriodId}
								filterPayTypeId={filterPayTypeId}
								filterClassificationId={filterClassificationId}
								userAccess={userAccess}
								type={type}
								showPostMessage={showPostMessage}
								isGenerate={isGenerate}
								isRevert={isRevert}
								isProcess={isProcess}
								isPost={isPost}
								isUpload={isUpload}
								setIsUpload={setIsUpload}
								loadingOtherAddition={loadingOtherAddition}
								loadingOtherDedujction={loadingOtherDedujction}
								loadingAdjustment={loadingAdjustment}
								loadingLateAdjustment={loadingLateAdjustment}
								filterDataAddition={filterDataAddition}
								filterDataDeduction={filterDataDeduction}
								filterDataAdjustment={filterDataAdjustment}
								filterDataLateAdjustment={filterDataLateAdjustment}
								fetchAdditionData={fetchAdditionData}
								fetchDeductionData={fetchDeductionData}
								fetchAdjustmentData={fetchAdjustmentData}
								fetchLateAdjustmentData={fetchLateAdjustmentData}
								fetchDataProcessedPayroll={fetchDataProcessedPayroll}
								handleGenerateLateApprovedAdjustments={handleGenerateLateApprovedAdjustments}
								openLateAdjustmentForm={openLateAdjustmentForm}
								user={user}
							/>
						</div>
					</TabPanel>

					<TabPanel>
						<div className="mainte-body-top row">
							<SearchBar placeholder="Search by name..." handleFilter={handleFilter} />
						</div>
						<div className="payroll-tab-header row">
							<div className="payroll-tab-leftSide">
								<div className="flex space-x-1" style={{ padding: "10px" }}>
									<Button
										icon={<FileOpenIcon />}
										name={"EXTRACT"}
										className={"bg-cyan-500 hover:bg-cyan-600 border-none cursor-pointer"}
										onClick={exportToExcel}
									/>
									<Button
										icon={<NoteAddIcon />}
										name={"DELETE ALL"}
										className={"bg-red-500 hover:bg-red-600 border-none cursor-pointer"}
										onClick={deleteAllHandleClick}
									/>
								</div>
							</div>

							<div className="">

							</div>
						</div>
						<div className="payroll-table2 container">
							<CreateTable
								dataList={payrollData}
								dataHeader={processedHeader}
								dataAccessor={processedAccessor}
								editHandleClick={editHandleClick}
								deleteHandleClick={deleteHandleClick}
								currentPage={currentPage}
								setCurrentPage={setCurrentPage}
							/>
							{payrollData.length > 0 ? (
								<div></div>
							) : (
								<div>
									{loading ? (
										<div
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												height: "10vh",
											}}
										>
											<img src={loadingSpinner} alt="Loading..." />
										</div>
									) : (
										<div> {/*<p>No records to display</p>*/}</div>
									)}
								</div>
							)}
						</div>
					</TabPanel>
				</div>
			</Tabs>
			<AddProcessForm
				isOpen={showAddForm}
				onClose={closeAddHandleClick}
				payrollPeriodId={payrollPeriodId}
				employeePersonalInformationId={employeePersonalInformationId}
				employeePersonalInformationFullName={
					employeePersonalInformationFullName
				}
				payTypeId={payTypeId}
				totalEcola={totalEcola}
				totalAllowance={totalAllowance}
				totalTax={totalTax}
				totalDays={totalDays}
				totalDaysAbsents={totalDaysAbsents}
				totalAbsents={totalAbsents}
				totalDaysLeaves={totalDaysLeaves}
				totalLeaves={totalLeaves}
				totalDeduction={totalDeduction}
				totalAddition={totalAddition}
				totalAdjustment={totalAdjustment}
				rate={rate}
				totalNighDiff={totalNighDiff}
				totalHoursOTRegular={totalHoursOTRegular}
				totalOTRegular={totalOTRegular}
				totalHoursOTRegularExceeded={totalHoursOTRegularExceeded}
				totalOTRegularExceeded={totalOTRegularExceeded}
				totalHoursOTRestday={totalHoursOTRestday}
				totalOTRestday={totalOTRestday}
				totalHoursOTRestdayExceeded={totalHoursOTRestdayExceeded}
				totalOTRestdayExceeded={totalOTRestdayExceeded}
				totalHoursOTHolidaySpecial={totalHoursOTHolidaySpecial}
				totalOTHolidaySpecial={totalOTHolidaySpecial}
				totalHoursOTHolidaySpecialExceeded={totalHoursOTHolidaySpecialExceeded}
				totalOTHolidaySpecialExceeded={totalOTHolidaySpecialExceeded}
				totalHoursOTHolidayRegular={totalHoursOTHolidayRegular}
				totalOTHolidayRegular={totalOTHolidayRegular}
				totalHoursOTHolidayRegularExceeded={totalHoursOTHolidayRegularExceeded}
				totalOTHolidayRegularExceeded={totalOTHolidayRegularExceeded}
				totalHoursOTRestdayHolidaySpecial={totalHoursOTRestdayHolidaySpecial}
				totalOTRestdayHolidaySpecial={totalOTRestdayHolidaySpecial}
				totalHoursOTRestdayHolidaySpecialExceeded={
					totalHoursOTRestdayHolidaySpecialExceeded
				}
				totalOTRestdayHolidaySpecialExceeded={
					totalOTRestdayHolidaySpecialExceeded
				}
				totalHoursOTRestdayHolidayRegular={totalHoursOTRestdayHolidayRegular}
				totalOTRestdayHolidayRegular={totalOTRestdayHolidayRegular}
				totalHoursOTRestdayHolidayRegularExceeded={
					totalHoursOTRestdayHolidayRegularExceeded
				}
				totalOTRestdayHolidayRegularExceeded={
					totalOTRestdayHolidayRegularExceeded
				}
				totalSSS={totalSSS}
				totalPagibig={totalPagibig}
				totalPhilhealth={totalPhilhealth}
				totalHoursUndertime={totalHoursUndertime}
				totalUndertime={totalUndertime}
				totalHoursLate={totalHoursLate}
				totalLate={totalLate}
				totalBasic={totalBasic}
				totalGrossPay={totalGrossPay}
				totalNetPay={totalNetPay}
				dateProcessed={dateProcessed}
				userId={userId}
				setPayrollPeriodId={setPayrollPeriodId}
				setEmployeePersonalInformationId={setEmployeePersonalInformationId}
				setPayTypeId={setPayTypeId}
				setTotalEcola={setTotalEcola}
				setTotalAllowance={setTotalAllowance}
				setTotalTax={setTotalTax}
				setTotalDays={setTotalDays}
				setTotalDaysAbsents={setTotalDaysAbsents}
				setTotalAbsents={setTotalAbsents}
				setTotalDaysLeaves={setTotalDaysLeaves}
				setTotalLeaves={setTotalLeaves}
				setTotalDeduction={setTotalDeduction}
				setTotalAddition={setTotalAddition}
				setTotalAdjustment={setTotalAdjustment}
				setRate={setRate}
				setTotalNighDiff={setTotalNighDiff}
				setTotalHoursOTRegular={setTotalHoursOTRegular}
				setTotalOTRegular={setTotalOTRegular}
				setTotalHoursOTRegularExceeded={setTotalHoursOTRegularExceeded}
				setTotalOTRegularExceeded={setTotalOTRegularExceeded}
				setTotalHoursOTRestday={setTotalHoursOTRestday}
				setTotalOTRestday={setTotalOTRestday}
				setTotalHoursOTRestdayExceeded={setTotalHoursOTRestdayExceeded}
				setTotalOTRestdayExceeded={setTotalOTRestdayExceeded}
				setTotalHoursOTHolidaySpecial={setTotalHoursOTHolidaySpecial}
				setTotalOTHolidaySpecial={setTotalOTHolidaySpecial}
				setTotalHoursOTHolidaySpecialExceeded={
					setTotalHoursOTHolidaySpecialExceeded
				}
				setTotalOTHolidaySpecialExceeded={setTotalOTHolidaySpecialExceeded}
				setTotalHoursOTHolidayRegular={setTotalHoursOTHolidayRegular}
				setTotalOTHolidayRegular={setTotalOTHolidayRegular}
				setTotalHoursOTHolidayRegularExceeded={
					setTotalHoursOTHolidayRegularExceeded
				}
				setTotalOTHolidayRegularExceeded={setTotalOTHolidayRegularExceeded}
				setTotalHoursOTRestdayHolidaySpecial={
					setTotalHoursOTRestdayHolidaySpecial
				}
				setTotalOTRestdayHolidaySpecial={setTotalOTRestdayHolidaySpecial}
				setTotalHoursOTRestdayHolidaySpecialExceeded={
					setTotalHoursOTRestdayHolidaySpecialExceeded
				}
				setTotalOTRestdayHolidaySpecialExceeded={
					setTotalOTRestdayHolidaySpecialExceeded
				}
				setTotalHoursOTRestdayHolidayRegular={
					setTotalHoursOTRestdayHolidayRegular
				}
				setTotalOTRestdayHolidayRegular={setTotalOTRestdayHolidayRegular}
				setTotalHoursOTRestdayHolidayRegularExceeded={
					setTotalHoursOTRestdayHolidayRegularExceeded
				}
				setTotalOTRestdayHolidayRegularExceeded={
					setTotalOTRestdayHolidayRegularExceeded
				}
				setTotalSSS={setTotalSSS}
				setTotalPagibig={setTotalPagibig}
				setTotalPhilhealth={setTotalPhilhealth}
				setTotalHoursUndertime={setTotalHoursUndertime}
				setTotalUndertime={setTotalUndertime}
				setTotalHoursLate={setTotalHoursLate}
				setTotalLate={setTotalLate}
				setTotalBasic={setTotalBasic}
				setTotalGrossPay={setTotalGrossPay}
				setTotalNetPay={setTotalNetPay}
				setDateProcessed={setDateProcessed}
				setUserId={setUserId}
				setShowEmployeeForm={setShowEmployeeForm}
				handleSubmit={handleSubmit}
			></AddProcessForm>
			<EditProcessForm
				isOpen={showEditForm}
				onClose={closeEditHandleClick}
				payrollPeriodId={payrollPeriodId}
				employeePersonalInformationId={employeePersonalInformationId}
				employeePersonalInformationFullName={
					employeePersonalInformationFullName
				}
				payTypeId={payTypeId}
				totalEcola={totalEcola}
				totalAllowance={totalAllowance}
				totalTax={totalTax}
				totalDays={totalDays}
				totalDaysAbsents={totalDaysAbsents}
				totalAbsents={totalAbsents}
				totalDaysLeaves={totalDaysLeaves}
				totalLeaves={totalLeaves}
				totalDeduction={totalDeduction}
				totalAddition={totalAddition}
				totalAdjustment={totalAdjustment}
				rate={rate}
				totalNighDiff={totalNighDiff}
				totalHoursOTRegular={totalHoursOTRegular}
				totalOTRegular={totalOTRegular}
				totalHoursOTRegularExceeded={totalHoursOTRegularExceeded}
				totalOTRegularExceeded={totalOTRegularExceeded}
				totalHoursOTRestday={totalHoursOTRestday}
				totalOTRestday={totalOTRestday}
				totalHoursOTRestdayExceeded={totalHoursOTRestdayExceeded}
				totalOTRestdayExceeded={totalOTRestdayExceeded}
				totalHoursOTHolidaySpecial={totalHoursOTHolidaySpecial}
				totalOTHolidaySpecial={totalOTHolidaySpecial}
				totalHoursOTHolidaySpecialExceeded={totalHoursOTHolidaySpecialExceeded}
				totalOTHolidaySpecialExceeded={totalOTHolidaySpecialExceeded}
				totalHoursOTHolidayRegular={totalHoursOTHolidayRegular}
				totalOTHolidayRegular={totalOTHolidayRegular}
				totalHoursOTHolidayRegularExceeded={totalHoursOTHolidayRegularExceeded}
				totalOTHolidayRegularExceeded={totalOTHolidayRegularExceeded}
				totalHoursOTRestdayHolidaySpecial={totalHoursOTRestdayHolidaySpecial}
				totalOTRestdayHolidaySpecial={totalOTRestdayHolidaySpecial}
				totalHoursOTRestdayHolidaySpecialExceeded={
					totalHoursOTRestdayHolidaySpecialExceeded
				}
				totalOTRestdayHolidaySpecialExceeded={
					totalOTRestdayHolidaySpecialExceeded
				}
				totalHoursOTRestdayHolidayRegular={totalHoursOTRestdayHolidayRegular}
				totalOTRestdayHolidayRegular={totalOTRestdayHolidayRegular}
				totalHoursOTRestdayHolidayRegularExceeded={
					totalHoursOTRestdayHolidayRegularExceeded
				}
				totalOTRestdayHolidayRegularExceeded={
					totalOTRestdayHolidayRegularExceeded
				}
				totalSSS={totalSSS}
				totalPagibig={totalPagibig}
				totalPhilhealth={totalPhilhealth}
				totalHoursUndertime={totalHoursUndertime}
				totalUndertime={totalUndertime}
				totalHoursLate={totalHoursLate}
				totalLate={totalLate}
				totalBasic={totalBasic}
				totalGrossPay={totalGrossPay}
				totalNetPay={totalNetPay}
				dateProcessed={dateProcessed}
				userId={userId}
				setPayrollPeriodId={setPayrollPeriodId}
				setEmployeePersonalInformationId={setEmployeePersonalInformationId}
				setPayTypeId={setPayTypeId}
				setTotalEcola={setTotalEcola}
				setTotalAllowance={setTotalAllowance}
				setTotalTax={setTotalTax}
				setTotalDays={setTotalDays}
				setTotalDaysAbsents={setTotalDaysAbsents}
				setTotalAbsents={setTotalAbsents}
				setTotalDaysLeaves={setTotalDaysLeaves}
				setTotalLeaves={setTotalLeaves}
				setTotalDeduction={setTotalDeduction}
				setTotalAddition={setTotalAddition}
				setTotalAdjustment={setTotalAdjustment}
				setRate={setRate}
				setTotalNighDiff={setTotalNighDiff}
				setTotalHoursOTRegular={setTotalHoursOTRegular}
				setTotalOTRegular={setTotalOTRegular}
				setTotalHoursOTRegularExceeded={setTotalHoursOTRegularExceeded}
				setTotalOTRegularExceeded={setTotalOTRegularExceeded}
				setTotalHoursOTRestday={setTotalHoursOTRestday}
				setTotalOTRestday={setTotalOTRestday}
				setTotalHoursOTRestdayExceeded={setTotalHoursOTRestdayExceeded}
				setTotalOTRestdayExceeded={setTotalOTRestdayExceeded}
				setTotalHoursOTHolidaySpecial={setTotalHoursOTHolidaySpecial}
				setTotalOTHolidaySpecial={setTotalOTHolidaySpecial}
				setTotalHoursOTHolidaySpecialExceeded={
					setTotalHoursOTHolidaySpecialExceeded
				}
				setTotalOTHolidaySpecialExceeded={setTotalOTHolidaySpecialExceeded}
				setTotalHoursOTHolidayRegular={setTotalHoursOTHolidayRegular}
				setTotalOTHolidayRegular={setTotalOTHolidayRegular}
				setTotalHoursOTHolidayRegularExceeded={
					setTotalHoursOTHolidayRegularExceeded
				}
				setTotalOTHolidayRegularExceeded={setTotalOTHolidayRegularExceeded}
				setTotalHoursOTRestdayHolidaySpecial={
					setTotalHoursOTRestdayHolidaySpecial
				}
				setTotalOTRestdayHolidaySpecial={setTotalOTRestdayHolidaySpecial}
				setTotalHoursOTRestdayHolidaySpecialExceeded={
					setTotalHoursOTRestdayHolidaySpecialExceeded
				}
				setTotalOTRestdayHolidaySpecialExceeded={
					setTotalOTRestdayHolidaySpecialExceeded
				}
				setTotalHoursOTRestdayHolidayRegular={
					setTotalHoursOTRestdayHolidayRegular
				}
				setTotalOTRestdayHolidayRegular={setTotalOTRestdayHolidayRegular}
				setTotalHoursOTRestdayHolidayRegularExceeded={
					setTotalHoursOTRestdayHolidayRegularExceeded
				}
				setTotalOTRestdayHolidayRegularExceeded={
					setTotalOTRestdayHolidayRegularExceeded
				}
				setTotalSSS={setTotalSSS}
				setTotalPagibig={setTotalPagibig}
				setTotalPhilhealth={setTotalPhilhealth}
				setTotalHoursUndertime={setTotalHoursUndertime}
				setTotalUndertime={setTotalUndertime}
				setTotalHoursLate={setTotalHoursLate}
				setTotalLate={setTotalLate}
				setTotalBasic={setTotalBasic}
				setTotalGrossPay={setTotalGrossPay}
				setTotalNetPay={setTotalNetPay}
				setDateProcessed={setDateProcessed}
				setUserId={setUserId}
				handleUpdate={handleUpdate}
			></EditProcessForm>
			<DeleteForm
				isOpen={showDeleteForm}
				onClose={closeDeleteHandleClick}
				handleDelete={handleDelete}
			></DeleteForm>
			<DeleteAllPayrollSummaryForm
				isOpen={showDeleteAllForm}
				onClose={closeDeleteAllHandleClick}
				payrollPeriodId={payrollIdForDelete}
				setPayrollPeriodId={setPayrollIdForDelete}
				handleDelete={handleDeleteAll}
			></DeleteAllPayrollSummaryForm>
			<EmployeeSelectForm
				isOpen={showEmployeeForm}
				onClose={closeEmployeeForm}
				setEmployeeId={setEmployeePersonalInformationId}
				setEmployee={setEmployeePersonalInformationFullName}
				userAccessData={userAccess}
			></EmployeeSelectForm>
			<GenerateMessage
				form={successPostMessage}
				message={"Data posted!"}
				isSuccess={true}
			></GenerateMessage>
			<GenerateMessage
				form={showRequestMessage}
				message={isSuccess ? "Request Success!" : requestMessage}
				isSuccess={isSuccess}
			></GenerateMessage>
			{loadingRequest ? (
				<div
					style={{
						position: "fixed",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						zIndex: "3005",
					}}
				>
					<img src={loadingSpinner} alt="Loading..." />
				</div>
			) : (
				<></>
			)}
		</div>
	);
}